module.exports = __webpack_public_path__ + "img/ringer.3bd23e01.svg";